<template>
  <PublicShell :color="data && data.brand ? data.brand.color : null" wide>
    <div v-if="loading" class="pw-loading" role="status"><span class="pb-sr-only">Loading…</span>
      <span class="pb-skeleton pw-sk1"></span><span class="pb-skeleton pw-sk2"></span>
      <div class="pw-sk-grid"><span v-for="n in 6" :key="n" class="pb-skeleton pw-sk-card"></span></div></div>
    <div v-else-if="!data || !data.available" class="pw-message">
      <span class="pb-empty-icon" aria-hidden="true"><i class="mdi mdi-eye-off-outline"></i></span>
      <h1 class="pw-title display-font">{{ data && data.brand ? data.brand.name : 'Testimonials' }}</h1>
      <p class="pb-body">{{ failed ? 'We couldn\'t load this page. Check your connection and try again.' : 'This page isn\'t available right now.' }}</p>
    </div>
    <WallBody v-else :brand="data.brand" :settings="{ headline: data.headline, intro: data.intro, show_rating: data.show_rating }" :layout="data.layout"
              :items="data.items" :disclosure="data.disclosure" :removal-url="data.removal_url" :attribution="data.attribution" />
  </PublicShell>
</template>

<script>
import PublicShell from '../components/PublicShell.vue';
import WallBody from '../components/WallBody.vue';
import { get } from '../api';

export default {
  name: 'PublicWallView',
  components: { PublicShell, WallBody },
  data: () => ({ data: null, loading: true, failed: false }),
  async mounted() {
    try {
      this.data = await get('/public/walls/' + encodeURIComponent(this.$route.params.slug));
      if (this.data.available) document.title = this.data.headline + ' · ' + this.data.brand.name;
    } catch (error) {
      this.failed = !(error.response && error.response.status === 404);
    } finally { this.loading = false; }
  }
};
</script>

<style scoped>
.pw-message{text-align:center;padding:64px 24px}
.pw-message .pb-body{max-width:420px;margin:10px auto 0}
.pw-title{font:500 30px/1.2 var(--font-display)!important;margin:0}
.pw-loading{display:grid;gap:14px}
.pw-sk1{height:24px;width:220px}
.pw-sk2{height:44px;width:60%}
.pw-sk-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(min(280px,100%),1fr));gap:18px;margin-top:16px}
.pw-sk-card{height:180px;border-radius:16px}
</style>
